"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
var _default = exports.default = {
  uploadFile: function uploadFile(data) {
    return (0, _request.default)({
      module: 'CORE',
      timeout: 5000000,
      headers: {
        'content-type': 'multipart/form-data'
      },
      url: "/protected/file/upload",
      method: 'post',
      data: data
    });
  },
  downloadFile: function downloadFile(uuid) {
    return (0, _request.default)({
      module: 'CORE',
      // url: `/protected/file/sas_download/${uuid}`,
      url: "/public/fileSecurity/sas_download/".concat(uuid),
      method: 'get'
    });
  },
  getRegionList: function getRegionList(level) {
    return (0, _request.default)({
      module: 'CORE',
      url: "public/provinces/query/".concat(level),
      method: 'get'
    });
  },
  getSRRegionList: function getSRRegionList(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: "protected/areaRefSr/regionList",
      method: 'post',
      data: data
    });
  },
  getFttExcelInfo: function getFttExcelInfo(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/excel_batch/listBatchDetail',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getImportProcess: function getImportProcess(redisKey, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/excel_batch/getProcess/' + redisKey,
      method: 'get',
      cancelToken: cancelToken
    });
  },
  downloadResultExcel: function downloadResultExcel(batchId) {
    return (0, _request.default)({
      module: 'CORE',
      timeout: 5000000,
      url: '/protected/excelDetailOrg/export/error/' + batchId,
      responseType: 'blob',
      method: 'post'
    });
  },
  getConfigItemByCode: function getConfigItemByCode(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/configItem/queryByCode',
      method: 'post',
      data: data
    });
  },
  getVersion: function getVersion() {
    return (0, _request.default)({
      module: 'CORE',
      url: 'protected/releaseManagement/getVersionCode',
      method: 'get'
    });
  }
};